import SparkMD5 from "spark-md5";
import tcutils from "./tcutils";
import Chunk from "./tcchunk"

function TcFile (uploader, file, parent) {
  tcutils.defineNonEnumerable(this, 'uploader', uploader)
  this.file = file
  this.fileType = this.file.type
  this.name = file.fileName || file.name
  this.size = file.size
  this.chunks = [];
  this.averageSpeed = 0;
  this.currentSpeed = 0;
  this.currentUploadIndex=0;
  this._lastProgressCallback = Date.now()
  this._prevUploadedSize = 0
  this.prevProgress = 0
  this.state = Chunk.STATUS.PENDING
  this.md5 = ""
  this.md5prevProgress=0
}

var FILESTATUS = TcFile.STATUS = {
  CHUNKING: 'chunking',
  PAUSE:'pause',
  COMPUTEMD5:'computemd5',
  REMOVED:"removed"
}

tcutils.extend(TcFile.prototype, {
  // 恢复
  resume: function async () {
    this.uploadChunks(0);
    this.state = Chunk.STATUS.UPLOADING
  },
  uploadChunks: function (index){
    for (let i = 0; i < this.chunks.length; i++) {
      let item = this.chunks[i];
      if( i === index ){
        if( item.chunk.url != 'success' && item.chunk.url.length > 0 && item.chunk.state !== Chunk.STATUS.COMPLETE){
          this.currentUploadIndex = index;
          console.log(`正在上传第${item.chunk.chunkNum}片`)
          item.chunk.send(item.chunk.url,item.file);
        }else{
          index++
        }
      }
    }
  },
  // 暂停
  pause: function () {
    console.log('暂停本文件上传');
    this.abort()
    this.state = FILESTATUS.PAUSE;
    this.uploader.upload()
  },
  // 取消
  cancel: function () {
    console.log('取消本文件上传');
    if(this.state == FILESTATUS.COMPUTEMD5){
      this.state = FILESTATUS.REMOVED
    }else{
      this.state = FILESTATUS.REMOVED
      this.abort()
    }
    this.uploader._trigger('fileRemove',this);
    this.uploader.upload()
  },
  // 重试
  retry: async function (file) {
    await this.bootstrap()
  },
  abort: function (reset) {
    this.currentSpeed = 0
    this.averageSpeed = 0
    var chunks = this.chunks
    if (reset) {
      this.chunks = []
    }
    var uploadingStatus = Chunk.STATUS.UPLOADING
    tcutils.each(chunks, function (c) {
      if (c.chunk.state === uploadingStatus) {
        c.chunk.abort()
      }
    }, this)
  },
  error: function(_chunkNum){
    this.state = Chunk.STATUS.ERROR
  },
  // 标记文件已经传输完成
  isCompleted:function(state){
    this.state = state != undefined ? state : Chunk.STATUS.COMPLETE

    console.log(`本文件${this.name}上传完了`)
    if( this.state !== "flashcomplete"){
      this.uploader._trigger('fileNnotify',this)
    }
    this.uploader.upload()

  },
  notify:function(){
    this.uploader._trigger('fileNnotify',this)
  },
  fileChunk: function(size){
    if(this.file.size / size > 100){
      size = Math.round(this.file.size / 100)
    }
    this.state = FILESTATUS.CHUNKING
    const fileChunkList = [];
    let cur = 0;
    let _chunkNum  = 0;
    while (cur < this.file.size) {
      _chunkNum++
      let fileData = this.file.slice(cur, cur + size);
      let _fileChunk = new Chunk(this.uploader, this, _chunkNum,fileData)
      fileChunkList.push({ file: fileData,chunk: _fileChunk});
      cur += size;
    }
    this.chunks = fileChunkList;
  },
  computeMD5 : function(){
    return new Promise(resolve => {
      this.state = FILESTATUS.COMPUTEMD5
      let percentage = 0;
      let count = 0;
      let spark = new SparkMD5.ArrayBuffer();
      let fileChunkList = this.chunks;
      const loadNext = index => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(fileChunkList[index].file);
        reader.onload = e => {
          if(this.state === FILESTATUS.REMOVED){
            resolve('removed');
          }else{
            count++;
            spark.append(e.target.result);
            if (count === fileChunkList.length) {
              let md5 = spark.end();
              console.log(`MD5计算完毕：${this.file.name} \nMD5：${md5} \n分片：${fileChunkList.length} 大小:${this.file.size}`);
              // md5 = md5 + new Date().getTime();
              this.state = Chunk.STATUS.PENDING
              resolve(md5);
            } else {
              percentage += 100 / fileChunkList.length;
              loadNext(count);
              this.md5prevProgress = (percentage).toFixed(0) + '%'
              console.log(this.file.name + '校验MD5 ' + (percentage).toFixed(0) + '%');
            }
          }
        };
        reader.onerror = function () {
          console.log(`文件${this.file.name}读取出错，请检查该文件`)
        };
      };
      loadNext(0);
    });
  },
  oneChunkComplete:function(_chunkNum){
    let _allComplete = true;
    for (let i = 0; i < this.chunks.length; i++) {
       if(this.chunks[i].chunk.state !== Chunk.STATUS.COMPLETE) {
          _allComplete = false;
       }
    }
    if(_allComplete){
      this.isCompleted()
    }else{
      this.currentUploadIndex++;
      this.uploadChunks(this.currentUploadIndex)
    }
  },
  updateProgress:function(){
    let total = this.chunks.length * 100;
    let  _allprogress = 0;
    this.chunks.forEach((item)=>{
      if(item.chunk.state === Chunk.STATUS.COMPLETE){
        item.chunk.uploadProgress = 100;
      }
      _allprogress = _allprogress + item.chunk.uploadProgress;
    });
    this.prevProgress = _allprogress/total
    this._measureSpeed()
    this._lastProgressCallback = Date.now()
    console.log('总体进度', this.prevProgress);
  },
  bootstrap: async function  () {
    this.abort(true)
    this.prevProgress = 0
    this.fileChunk(this.uploader.opts.chunkSize)
    this.md5 = await this.computeMD5();
    if(this.md5 !== "removed"){
      this.uploader._trigger('fileverifyupload', this);
    }

  },
  _measureSpeed: function () {
    let smoothingFactor = this.uploader.opts.speedSmoothingFactor
    let timeSpan = Date.now() - this._lastProgressCallback
    if (!timeSpan) {
      return
    }
    let uploaded = this.sizeUploaded()
    this.currentSpeed = Math.max((uploaded - this._prevUploadedSize) / timeSpan * 1000, 0)
    this.averageSpeed = smoothingFactor * this.currentSpeed + (1 - smoothingFactor) * this.averageSpeed
    this._prevUploadedSize = uploaded
  },
  sizeUploaded: function () {
    var size = 0
    tcutils.each(this.chunks, function (chunk) {
      size += chunk.chunk.sizeUploaded()
    })
    return size
  },
})
export default TcFile
